import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import UserDashboardSidebar from '../components/UserDashboardSidebar';
import axios from 'axios';
import moment from 'moment';


class RegisteredSurgeries extends Component {
  state = {
    registeredSurgeries: []
  }

  componentDidMount = () => {
    this.getSurgeries();
  }

  getSurgeries = () => {
    axios.get(`/api/user/registeredsurgeries/all`)
      .then(res => {
        this.setState({ registeredSurgeries: res.data })
      });
  }

  render() {
    if (!this.props.state.loggedIn) {
      return (
        <div className="main-view">
          <p>Dashboard Page</p>
          <p>Please Log In</p>
        </div>
      )
    }
    return (
      <div className='dashboard--has-sidebar'>
        <UserDashboardSidebar
          userInfo={this.props.state}
          {...this.props}
        />
        <div className='dashboard'>
          <main className='wrapper'>
            <section className='section'>
              <div className='content'>
                <div className="admin-dashboard__grid">
                  <div className="latest-posts">
                    <header className="d-flex w-100 justify-content-between align-items-center mb-4">
                      <h1 className='title mb-0 h4'>Registered Surgeries</h1>
                    </header>

                    <div className="list-group">
                      {this.state.registeredSurgeries.length ?
                        <>
                          {this.state.registeredSurgeries.map(surgery => (
                            <Link to={`/surgeries/${surgery._id}`} className="list-group-item list-group-item-action">
                              <div className="d-flex w-100 justify-content-between">
                                <h6 className="mb-1">{surgery.topic}</h6>
                                <small>{moment(surgery.start_time).calendar()}</small>
                              </div>
                              <small>{surgery.doctor}</small>
                            </Link>
                          ))}
                        </>
                        :
                        <div>
                          Currently, you are not registered to any upcoming surgeries.
                        </div>

                      }

                    </div>

                  </div>
                </div>
              </div>
            </section>
          </main>
        </div>
      </div>
    )
  }
}

export default RegisteredSurgeries;